import axios from 'axios';

class TokenService {
  readonly tokenKey = 'token';

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  saveToken(token: string) {
    localStorage.setItem(this.tokenKey, token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  // The header goes too, or every later request would still present the old session
  removeToken() {
    localStorage.removeItem(this.tokenKey);
    delete axios.defaults.headers.common['Authorization'];
  }
}

export default new TokenService();
